export const urlWithoutHeaderAndFooter = [
  '/good-bye',
  '/unsubscribe-communications',
  '/support'
];
